import * as React from 'react'
import {ISwiperComponentProps} from "./ISwiperComponentProps";
import {ISwiperComponentState} from "./ISwiperComponentState";
import 'src/assets/css/main.css';
import 'src/assets/css/reset.css';
import 'src/assets/css/fonts.css';
import 'src/assets/css/hover.css';
import 'src/assets/css/swiper.min.css';
import PostSwiperComponent from "../postSwiperComponent/PostSwiperComponent";
import AliceCarousel from 'react-alice-carousel'
import "react-alice-carousel/lib/alice-carousel.css"
import Backend from "../../api/Backend";
import { Link, withRouter } from 'react-router-dom'
import axios from 'axios'
export class SwiperComponent extends React.Component<ISwiperComponentProps, ISwiperComponentState>{


    constructor(props: ISwiperComponentProps) {
        super(props)
        // Default state
        this.state = {
            currentIndex: 0,
            itemsInSlide: 1,
            responsive: { 0: { items: 3 }},
            galleryItems: [],

        }
    }




     componentDidMount() {

        let items = []


         axios.get('https://europe-west1-ttgif-3c665.cloudfunctions.net/featured?nb=6').then(res =>{
             res.data.forEach(item => {
                 items.push(
                     <PostSwiperComponent id={item.id} favorites={item.favorites} image={item.URL} title={item.title} />  )
             })
             this.setState({
                 galleryItems: items
             })


         })






        /*Backend.database().ref('gifs/' ).once('value' ,(snapshot) =>{
                snapshot.forEach(item => {
                    items.push(
                        <PostSwiperComponent id={item.val().id} favorites={item.val().favorites} image={item.val().URL} title={item.val().title} />  )
                })
            this.setState({
                galleryItems: items
            })

        })*/

    }

    slidePrevPage = () => {
        const currentIndex = this.state.currentIndex - this.state.itemsInSlide
        this.setState({ currentIndex })
    }

    slideNextPage = () => {
        const { itemsInSlide, galleryItems: { length }} = this.state
        let currentIndex = this.state.currentIndex + itemsInSlide
        if (currentIndex > length) currentIndex = length

        this.setState({ currentIndex })
    }

    handleOnSlideChange = (event) => {
        const { itemsInSlide, item } = event
        this.setState({ itemsInSlide, currentIndex: item })
    }






    responsive = {
        0: { items: 1 },
        1024: { items: 5 },
    }

    onSlideChange(e : any) {
        console.debug('Item`s position during a change: ', e.item)
        console.debug('Slide`s position during a change: ', e.slide)
    }

    onSlideChanged(e :any) {
        console.debug('Item`s position after changes: ', e.item)
        console.debug('Slide`s position after changes: ', e.slide)
    }


    public render() {



        const { currentIndex, galleryItems, responsive } = this.state

        return (
               <section className="_swiper">
                  <div className="swiper-container container">
                      <div className="swiper-wrapper">
                          <div className=" swiper-slide">
                              <AliceCarousel
                                  items={galleryItems}
                                  slideToIndex={currentIndex}
                                  onInitialized={this.handleOnSlideChange}
                                  onSlideChanged={this.handleOnSlideChange}
                                  onResized={this.handleOnSlideChange}
                                  responsive={responsive}
                                  autoPlayInterval={2000}
                                  autoPlayDirection="rtl"
                                  autoPlay={true}
                                  fadeOutAnimation={true}
                                  mouseDragEnabled={true}
                                  playButtonEnabled={false}
                                  disableAutoPlayOnAction={false}
                                  onSlideChange={this.handleOnSlideChange}
                                  buttonsDisabled={true}
                                  dotsDisabled={true}
                              />
                          </div>
                      </div>
                  </div>



                   <div className="container"  onClick={this.slidePrevPage}>
                       <div className="swiperBtn leftArraow"></div>
                   </div>
                   <div className="container" onClick={this.slideNextPage}>
                       <div className="swiperBtn rightArraow"></div>
                   </div>
              </section>




        );

    }

}

export default (withRouter(SwiperComponent))



// WEBPACK FOOTER //
// ./src/components/swiperComponent/SwiperComponent.tsx